<template>
	<div class="news">
		<van-sticky>
			<div :class="{search:true,skin_bgcolor:true}">
				<img round class="logo" :src="Conf.clientOrigin+'/assets/image/logo.png'" @click.stop="gohome()"/>
				<div class="input-box">
					<input 
					type="text" 
					class="input" 
					placeholder="输入搜索内容百度一下" 
					v-model='inputText' 
					@keyup='show($event)' 
					@keydown.down='down()' 
					@keydown.up.prevent='up()'
					>
				</div>
				<span class="baidu" @click="goto()">
					<!--input type="submit" value="百度一下" --><van-icon name="search" size="22px" color="#fff"/>
				</span>

			</div>
		</van-sticky>
		<div class="search-list" v-show="result.length>0&&this.inputText">
			<ul>
				<li v-for="(item, index) in result" :class='{bgcolor: index==nowIndex}' @click="gotoItem(item)">
				{{item}}
				</li>
			</ul>
		</div>

		<van-tabs v-model="tabact" swipeable sticky  @change="tabChange" offset-top="40px">
			<van-tab v-for="(nav,index) in newsNav" :key="index" :title="nav.name">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<div class="empty" v-if="items.length==0"></div>
					<van-list
					v-model="loading"
					:loading="'加载中，请稍候……'"
					:finished="finished"
					:finished-text="items.length==0?('暂无 '+nav.name+' 相关内容！'):'没有更多内容了'"
					@load="loadData"
					>
						<div class="info"
						  v-for="(item,index) in items"
						  :key="index"
						  @click="viewNewsInfo(item)"
						>
							<div :class="{'van-hairline--bottom box':true,'imgl':(nav.conf&&nav.conf.img=='left'&&!item.thumbnail_pic_s02),'imgr':(nav.conf&&nav.conf.img=='right'&&!item.thumbnail_pic_s02)}">
								<div class="title">
									<van-tag type="danger" plain style="margin-right:5px;" v-if="item.set_top">置顶</van-tag>
									<span class="skin_color" :style="'font-weight:bold;'">{{filterHistory(item.date,nav.key)}}</span>{{item.title}}
								</div>
								<div class="img" v-if="item.thumbnail_pic_s">
									<van-image fit="cover" :class="(item.thumbnail_pic_s02||item.thumbnail_pic_s03)?'w30':'w100'" :src="item.thumbnail_pic_s" />
									<van-image fit="cover" class="w30" :src="item.thumbnail_pic_s02" v-if="item.thumbnail_pic_s02"/>
									<van-image fit="cover" class="w30" :src="item.thumbnail_pic_s03" v-if="item.thumbnail_pic_s03"/>
								</div>
								<div class="note">
									<span class="author">{{item.author_name}}</span>
									<span class="date" v-show="!(nav.conf&&nav.conf.time=='none')&&!item.set_top">{{filterTimes(item.date,nav.key)}}</span>
								</div>
							</div>
						</div>
					</van-list>
				</van-pull-refresh>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script type="text/ecmascript-6">
import {Sticky, Tab, Tabs,List,Search} from "vant";

export default {
	name: "store",
	components: {
		"van-sticky": Sticky,
		"van-tab": Tab,
		"van-tabs": Tabs,
		"van-list": List,
		"van-search":Search
	},
	data() {
		return {
			title: "",
			attach_url:this.Conf.serverPre,
			newsNav:this.Conf.newsNav,
			tabact:0,
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),

			items: [],
			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false,

			inputText: '',
			text: '',
			nowIndex: -1,
			result: []
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
		
	},
	created() {
		this.getStateConfigs();
		this.loadData();
	},
	methods: {
		gohome(){
			if (window.plus) {
				plus.runtime.openURL(this.Conf.clientOrigin);
			} else {
				window.open(this.Conf.clientOrigin);
			}
		},
		getStateConfigs(){
			const navs = this.$store.state.common.news_nav;
			if(navs){
				this.newsNav = navs;
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		loadData() {
			if (this.finished) {
				return false;
			}
			this.loading = true;
			setTimeout(() => {
				if (this.refreshing) {
					this.items = [];
					this.refreshing = false;
				}
				this.page = this.page+1;

				var params = {
					p: this.page
				};
				var url = this.Conf.serverUrl + "news/" + this.newsNav[this.tabact].key +"/list?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
						if (response.data.page == 1) {
							this.pageSize = response.data.pageSize;
							this.total = response.data.total;
							this.items = response.data.data;
						}else if(response.data.data){
							this.items = this.items.concat(response.data.data);
						}
						if(this.page*this.pageSize >= this.total){
							this.finished = true;
						}
						this.loading = false;
				})
				.catch(error => {});
			}, 1000);
		},
		onRefresh(cur){
			this.finished = false;
			this.page = cur?(this.page-1):0;
			this.loadData();
		},
		tabChange(){
			this.finished = false;
			this.page = 0;
			this.loadData();
		},
		viewNewsInfo(item){
			if(item.url){
				this.viewInfo(item.url);
				return false;
			}

			this.$router.push({ path: "/News/Info/"+item.uniquekey, query:item });
		},
		viewInfo(url){
			if(url){
				if (window.plus) {
					plus.runtime.openURL(url);
				} else {
					window.open(url);
				}
			}
		},
		show (ev) {
			let that = this;
			window.baidu={};
			try{
				window.baidu.sug=function(json){
					try{
						that.result = json.s;
						//that.$forceUpdate();
					}catch(e){}
				}
			}catch(e){}
			if (ev.keyCode == 38 || ev.keyCode == 40) {
				if (this.nowIndex < -1){
					return;
				}
				if (this.nowIndex != this.result.length && this.nowIndex != -1) {
					this.inputText = this.result[this.nowIndex];
				}
				return;
			}
			if (ev.keyCode == 13) {
				this.viewInfo('https://www.baidu.com/s?wd=' + this.inputText);
				//this.inputText = '';
			}
			this.text = this.inputText;
			if(this.inputText){
				this.$jsonp('https://sp0.baidu.com/5a1Fazu8AA54nxGko9WTAnF6hhy/su', 
				{
					wd: this.inputText,
					jsonp: 'cb'
					}).then(res => {
				})
			}
		},
		goto () {
			this.viewInfo('https://www.baidu.com/s?wd=' + this.inputText);
			//this.inputText = '';
		},
		gotoItem(item) {
			this.viewInfo('https://www.baidu.com/s?wd=' + item);
			//this.inputText = '';
		},
		down () {
			this.nowIndex++;
			if (this.nowIndex == this.result.length) {
				this.nowIndex = -1;
				this.inputText = this.text;
			}
		},
		up () {
			this.nowIndex--;
			if (this.nowIndex < -1){
				this.nowIndex = -1;
				return;
			}
			if (this.nowIndex == -1) {
				this.nowIndex = this.result.length;
				this.inputText = this.text;
			}
		}
	},
	computed:{
		filterTimes(){
			return function(t,k){
				if(k=="history"){
					return t.split(' ')[0];
				}else{
					var tt = new Date(t.replace(/-/g,'/')).getTime()/1000;
					return this.$options.filters['formatTime'](tt,'{y}-{m}-{d} {h}:{i}');
				}
			}
		},
		filterHistory(t,k){
			return function(t,k){
				if(k == "history" && !this.loading){
					var tt = new Date(t.replace(/-/g,'/'));
					return tt.getFullYear()+"年 ";
				}
				return "";
			}
		}
	},
	filters:{
	}
};
</script>
<style lang="less" scoped>
</style>




// WEBPACK FOOTER //
// src/components/News.vue